exports.init = function ($) {

  jQuery(document).ready(function () {
    calcAspectRatio();

  });
  jQuery(window).resize(function () {
    calcAspectRatio();
  });

  jQuery(document).on("click", ".video-btn", function (e) {
    jQuery(this).closest("#video-showcase").addClass("playing");
    jQuery(this).siblings("#yt")[0].src += "?autoplay=1&mute=1";
  });

  function calcAspectRatio() {
    var getHeight = (window.innerWidth * 1080) / 1920;
    var getWidth = (1920 * window.innerHeight) / 1080;
    if (getHeight < window.innerHeight) {
      jQuery(".bg-sec iframe").width(getWidth + 150);
      jQuery(".bg-sec iframe").height(window.innerHeight + 150);
    } else {
      jQuery(".bg-sec iframe").width(window.innerWidth + 150);
      jQuery(".bg-sec iframe").height(getHeight + 150);
    }
  }
  calcAspectRatio();

}